module.exports = __webpack_public_path__ + "static/media/road-king-special-deadwood-green.eef403a7.png";